import Vue, { KeepAlive } from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index.vue'
import ForumIndex from '@/components/ForumIndex.vue'
import ancPre from '@/components/ancPre.vue'

import ForumDetailv from '@/components/ForumDetailv.vue'
import ForumDetailw from '@/components/ForumDetailw.vue'
import HerbalMedicineIndex from '@/components/HerbalMedicineIndex.vue'
import HerbalMedicineDetail from '@/components/HerbalMedicineDetail.vue'
import LibraryIndex from '@/components/LibraryIndex.vue'
import JingLuoIndex from '@/components/JingLuoIndex.vue'
import jinluoandxuewei from '@/components/jinluoandxuewei.vue'
import Home from '@/components/Home.vue'

Vue.use(Router)

export default new Router({
  // mode: "history",
  routes: [
    //官网,以Home为跳转页面的页面
    {
      path: '/',
      name: 'Home',
      component: Home,
      redirect: '/index',
      children: [{
          name: '首页',
          path: '/index',
          component: Index,
          index: "1",
        },
        {
          path: '/searchList',
          name: '搜索列表',
          component: require("@/components/searchList.vue").default,
        },
        {
          name: '登陆',
          path: 'login',
          component: require("@/components/login.vue").default,
        },
        {
          name: '忘记密码',
          path: 'forgetP',
          component: require("@/components/forgetP.vue").default,
        },
        {
          name: '微信登陆',
          path: 'kong',
          component: require("@/components/kong.vue").default,
        },
        {
          name: '医师登陆',
          path: 'ysLogin',
          component: require("@/components/ysLogin.vue").default,
        },

        {
          name: '注册',
          path: 'register',
          component: require("@/components/register.vue").default,
        },
        {
          name: '医师注册',
          path: 'ysRegister',
          component: require("@/components/JW/ysRegister.vue").default,
        },
        {
          name: '医师用户注册',
          path: 'ysRegisterUser',
          component: require("@/components/JW/ysRegisterNew.vue").default,
        },
        {
          name: '批发商注册',
          path: 'wholesaler',
          component: require("@/components/JW/wholesaler.vue").default,
        },
        {
          name: '批发商用户注册',
          path: 'wholesalerUser',
          component: require("@/components/JW/wholesalerNew.vue").default,
        },
        {
          path: '/ForumIndex',
          name: '中医讲堂',
          component: ForumIndex,
          index: "1"
        },
        {
          path: '/ancPre',
          name: '古方大全',
          component: ancPre,
          index: "1"
        },
        {
          path: '/ForumDetailv',
          name: '讲堂详情视频',
          component: ForumDetailv,
        },
        {
          path: '/ForumDetailw',
          name: '讲堂详情文字',
          component: ForumDetailw,
        },
        {
          path: '/HerbalMedicineIndex',
          name: '中草药',
          component: HerbalMedicineIndex,
          index: "1"
        },
        {
          path: '/HerbalMedicineDetail',
          name: '中草药详情',
          component: HerbalMedicineDetail,
        },
        {
          path: '/LibraryIndex',
          name: '中医文库',
          component: LibraryIndex,
          index: "1"
        },
        {
          path: '/weiKuDetail',
          name: '文库详情',
          component: require("@/components/weiKuDetail.vue").default,
        },
        {
          path: '/JingLuoIndex',
          name: '经络穴位',
          component: JingLuoIndex,
          index: "1"
        },
        {
          path: '/JingLuoIndex',
          name: '经络穴位',
          component: JingLuoIndex,
        },
        {
          path: '/JingLuoDetail',
          name: '经络详情',
          component: require("@/components/JingLuoDetail.vue").default,
        },
        {
          path: '/questionnaire',
          name: '调查问卷',
          component: require("@/components/common/questionnaire.vue").default,
        },

        {
          path: '/ancPreDetail',
          name: '古方大全详情',
          component: require("@/components/ancPreDetail.vue").default,
        },
        {
          path: '/xueWeiIndex',
          name: '穴位列表',
          component: require("@/components/xueWeiIndex.vue").default,
        },
        {
          path: '/xueWeiDetail',
          name: '穴位详情',
          component: require("@/components/xueWeiDetail.vue").default,
        },
        {
          path: '/shuxueDetail',
          name: '腧穴详情',
          component: require("@/components/shuxueDetail.vue").default,
        },
        {
          path: '/aboutDetail',
          name: '关于我们',
          component: require("@/components/aboutDetail.vue").default,
        },
        {
          path: '/mian',
          name: '免责声明',
          component: require("@/components/mian.vue").default,
        },
        {
          path: '/yi',
          name: '隐私策略',
          component: require("@/components/yi.vue").default,
        },
        {
          path: '/tradiIndex',
          name: '中西会诊', 
          component: require("@/components/common/homeDoctor.vue").default,
          redirect: '/tradiIndexPage',
          children:[
            { 
              path: '/tradiIndexPage',
              name: '中西会诊',
              component: require("@/components/traditionalAndWest/tradiIndex.vue").default,
              meta:{keepAlive:true}
            },
            {
              name: '个人信息-医师',  
              path: '/doctorInfoT',
              component: require("@/components/JW/doctorInfo.vue").default,
            },
            {
              name: '我的患者-医师',
              path: '/myPatientsT',
              component: require("@/components/JW/myPatients.vue").default,
            },
            {
              name: '诊断信息详情-医师',
              path: '/diagnosticDetailsT',
              component: require("@/components/JW/diagnosticDetails.vue").default,
            },
            {
              path: '/tradiAddMedical',
              name: '中西会诊新增医案',
              component: require("@/components/traditionalAndWest/addMedical.vue").default,
            },
            {
              name: '诊断页面',
              path: '/diagnosisT',
              component: require("@/components/JW/diagnosis.vue").default,
            },
            {
              name: '我的收藏-医师',  
              path: '/myCollectionT',
              component: require("@/components/Orderlist/myCollection.vue").default,
            },
            {
              name: '购物车-医师', //购物车
              path: '/carT',
              component: require("@/components/ShoppingMall/car.vue").default,
            },
            {
              name: '我的订单-医师', //我的订单
              path: '/myOrderT',
              component: require("@/components/Orderlist/myOrder.vue").default,
            },
            {
              name: '我的地址-医师', //我的地址
              path: '/myAddressT',
              component: require("@/components/Orderlist/myAddress.vue").default,
            },
          ] 
        },
        {
          path: '/tradiInfo/:id?',
          name: '中西会诊详情',
          component: require("@/components/traditionalAndWest/tradiInfo.vue").default,
        }, 
      ]
    },

    //商城
    {
      path: '/Shopping',
      name: '商城',
      component: require("@/components/ShoppingMall/index.vue").default,
      children: [{
          name: 'ShopIndex',
          path: '/ShopIndex',
          component: require("@/components/ShoppingMall/ShopIndex.vue").default,
        },
        {
          name: 'commodity',
          path: '/commodity/:id?/:name?',
          component: require("@/components/ShoppingMall/commodity.vue").default,
        },
        {
          name: 'ProductDetails',
          path: '/ProductDetails/:id',
          component: require("@/components/ShoppingMall/ProductDetails.vue").default,
        },
      ]
    },

    //订单模块
    {
      path: '/OrderIndex',
      name: '订单',
      component: require("@/components/ShoppingMall/OrderIndex.vue").default,
      redirect: '/home2',
      children: [{
          name: 'OrderDetails', //商品订单详情
          path: '/OrderDetails',
          component: require("@/components/ShoppingMall/OrderDetails.vue").default,
        },
        {
          name: 'OrderCFDetails', //处方订单详情
          path: '/OrderCFDetails',
          component: require("@/components/ShoppingMall/OrderCFDetails.vue").default,
        },
        {
          name: 'logistics', //物流详情
          path: '/logistics',
          component: require("@/components/ShoppingMall/logistics.vue").default,
        },
        {
          name: 'evaluate', //商品评价
          path: '/evaluate',
          component: require("@/components/ShoppingMall/evaluate.vue").default,
        },
        {
          name: 'evaluateCF', //药方评价
          path: '/evaluateCF',
          component: require("@/components/ShoppingMall/evaluateCF.vue").default,
        },
        {
          name: 'ReceivingAddress', //立即购买
          path: '/ReceivingAddress',
          component: require("@/components/ShoppingMall/ReceivingAddress.vue").default,
        },
        {
          name: 'ReceivingAddress2', //立即购买2
          path: '/ReceivingAddress2',
          component: require("@/components/ShoppingMall/ReceivingAddress2.vue").default,
        },
        {
          name: 'payment', //商品支付
          path: '/payment',
          component: require("@/components/ShoppingMall/payment.vue").default,
        },
        {
          name: 'car', //购物车
          path: '/car',
          component: require("@/components/ShoppingMall/car.vue").default,
        },
        //拿到orderIndex的头部和尾部，
        //以Home2为跳转页面的页面,导航有个人中心，商城首页，消息
        {
          name: 'home2',
          path: '/home2',
          component: require("@/components/common/home2.vue").default,
          redirect: '/PersonalCenter',
          children: [{
              name: 'PersonalCenter', //个人中心
              path: '/PersonalCenter',
              component: require("@/components/JW/PersonalCenter.vue").default,
            },
            {
              name: '个人信息',
              path: '/personalInformation',
              component: require("@/components/JW/personalInformation.vue").default,
            },
            {
              name: '档案详情',
              path: '/archives',
              component: require("@/components/JW/archives.vue").default,
            },
            {
              name: '古方详情',
              path: '/ancientDetails',
              component: require("@/components/JW/ancientDetails.vue").default,
            },
            {
              name: '推荐结果',
              path: '/recResults',
              component: require("@/components/JW/recResults.vue").default,
            },
            {
              name: '医案添加',
              path: '/addMedical',
              component: require("@/components/JW/addMedical.vue").default,
            },
            {
              name: '我的患者',
              path: '/myPatients',
              component: require("@/components/JW/myPatients.vue").default,
            },
            {
              name: '我的医案/档案',
              path: '/myYiAn',
              component: require("@/components/JW/myYiAn.vue").default,
            },
            {
              name: '个人档案',
              path: '/personalFiles',
              component: require("@/components/JW/personalFiles.vue").default,
            },
            {
              name: '医师列表',
              path: '/doctorList',
              component: require("@/components/JW/doctorList.vue").default,
            },
            {
              name: '诊断信息详情',
              path: '/diagnosticDetails',
              component: require("@/components/JW/diagnosticDetails.vue").default,
            },
            {
              name: '诊断页面',
              path: '/diagnosis',
              component: require("@/components/JW/diagnosis.vue").default,
            },
            {
              name: 'message',
              path: '/message',
              component: require("@/components/JW/message.vue").default,
            },
            //个人中心设置部分
            {
              name: 'wholesalerInfo', //批发商信息
              path: '/wholesalerInfo',
              component: require("@/components/JW/wholesalerInfo.vue").default,
            },
            //医师信息
            {
              name: 'doctorInfo', //批发商信息
              path: '/doctorInfo',
              component: require("@/components/JW/doctorInfo.vue").default,
            },
            //个人中心商城部分
            {
              name: 'myOrder', //我的订单
              path: '/myOrder',
              component: require("@/components/Orderlist/myOrder.vue").default,
            },
            {
              name: 'myAddress', //我的地址
              path: '/myAddress',
              component: require("@/components/Orderlist/myAddress.vue").default,
            },
            {
              name: 'myCollection', //我的收藏
              path: '/myCollection',
              component: require("@/components/Orderlist/myCollection.vue").default,
            }

          ]
        }
      ]
    },
    // 个人中心中的商城
    {
      path: '/OrderList',
      name: '订单',
      component: require("@/components/OrderList/orderIndex.vue").default,
      children: [
        // {
        //   name: 'myOrder',//我的订单
        //   path: '/myOrder',
        //   component: require("@/components/Orderlist/myOrder.vue").default,
        // },
        // {
        //   name: 'myAddress',//我的地址
        //   path: '/myAddress',
        //   component: require("@/components/Orderlist/myAddress.vue").default,
        // },
        // {
        //   name: 'myCollection',//我的收藏
        //   path: '/myCollection',
        //   component: require("@/components/Orderlist/myCollection.vue").default,
        // },
      ]
    },
    //以noReturnShopHeadHome为跳转页面的页面,没有标题，没有返回商城按钮，有脚注
    {
      path: '/',
      name: 'noReturnShopHeadHome',
      component: require("@/components/common/noReturnShopHeadHome.vue").default,
      redirect: '/orderDetail',
      children: [{
        name: '订单详情',
        path: 'orderDetail',
        component: require("@/components/noTitleNoReturn/orderDetail.vue").default,
      }, ]
    },


  ]
})

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}



// WEBPACK FOOTER //
// ./src/router/index.js